import {useEffect, useState} from 'react';

import {BreadCrumb} from 'primereact/breadcrumb';
import {MegaMenu} from 'primereact/megamenu';
import {AppStorage} from '../service/UserStorage';
import {BehaviorSubject} from 'rxjs';
import  EventEmitter  from '../utils/EventEmitter';   
const breadcrumbs = new BehaviorSubject(null);
export const BreadcrumbsService = {
  setBreadcrumbs: data => breadcrumbs.next(data),
  getBreadcrumbs: () => breadcrumbs.asObservable()
};

const actions = new BehaviorSubject(null);
export const ActionsService = {
  setActions: data => actions.next(data),
  getActions: () => actions.asObservable()
};

export const AppBreadCrumb = () => {
  
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [actions, setActions] = useState([]);
  const [tenantInfo, setTenantInfo] = useState('');
  const [tenantTaxCode, setTenantTaxCode] = useState('');

  useEffect(() => {
    BreadcrumbsService.getBreadcrumbs().subscribe((data) => {
      setBreadcrumbs(data);
    });
    ActionsService.getActions().subscribe((data) => {
      setActions(data);
    });

    const changeTenantInfo = (tenantInfo) => {
      setTenantInfo(tenantInfo.name);
      setTenantTaxCode(tenantInfo.taxCode);
    }
    
    if(!tenantInfo) {
      let tenantInfoString = AppStorage.get('tenantInfo');
      if(tenantInfoString) {
        let tenantIncache = JSON.parse(tenantInfoString) || {};
        setTenantInfo(tenantIncache.name);
        setTenantTaxCode(tenantIncache.taxCode);
      }
    }
   
    const events = EventEmitter.addListener("changeTenantInfo", changeTenantInfo);
    return () => {
      events.removeListener("changeTenantInfo", changeTenantInfo)
    }
  }, []);

  const home = {icon: 'pi pi-home', url: '/'};

  return (
    <div className="layout-breadcrumb flex justify-content-between flex-wrap">
      <div className="flex align-items-center justify-content-center">
        <BreadCrumb model={breadcrumbs} home={home}/>
      </div>
      <div className="flex align-items-center justify-content-center">
        <MegaMenu model={actions}/>
      </div>
      <div className="flex align-items-right justify-content-right company-info">
      {tenantInfo}<br/> 
       
        MST: {tenantTaxCode} 
       
      </div>
    </div>
  );
}
